import { render } from "./AccountAccess.vue?vue&type=template&id=0364559f&ts=true"
import script from "./AccountAccess.vue?vue&type=script&lang=ts"
export * from "./AccountAccess.vue?vue&type=script&lang=ts"

import "./AccountAccess.vue?vue&type=style&index=0&id=0364559f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__